var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.41 10.42L10.41 1.42C10.05 1.06 9.55 0.839996 9 0.839996H2C0.9 0.839996 0 1.74 0 2.84V9.84C0 10.39 0.22 10.89 0.59 11.26L9.59 20.26C9.95 20.62 10.45 20.84 11 20.84C11.55 20.84 12.05 20.62 12.41 20.25L19.41 13.25C19.78 12.89 20 12.39 20 11.84C20 11.29 19.77 10.78 19.41 10.42ZM3.5 5.84C2.67 5.84 2 5.17 2 4.34C2 3.51 2.67 2.84 3.5 2.84C4.33 2.84 5 3.51 5 4.34C5 5.17 4.33 5.84 3.5 5.84Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2);
export default __webpack_public_path__ + "static/media/grid2.be33db18f659a812ebe8c4049116a699.svg";
export { ForwardRef as ReactComponent };